// PrintMenuItem.tsx
import React from 'react'
import { useReactToPrint } from 'react-to-print'
import { ReactComponent as PrintIcon } from '../assets/PrintIcon.svg'

export function PrintMenuItem({
  contentRef,
  onAfterPrint
}: {
  contentRef: React.RefObject<HTMLElement>
  onAfterPrint?: () => void
}) {
  const handlePrint = useReactToPrint({
    contentRef,
    pageStyle: '@page { size: A4; margin: 16mm }',
    documentTitle: 'Conversation',

    onAfterPrint
  })

  const disabled = !contentRef?.current

  return (
    <button className="btn" onClick={() => handlePrint?.()} disabled={disabled}>
      <PrintIcon className="menu-icon" />
      <span className="menu-main-text">Export PDF</span>
    </button>
  )
}
